var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-cascader',{staticStyle:{"width":"300px"},attrs:{"options":_vm.options,"load-data":_vm.loadData,"lazy":true,"placeholder":"请选择地区"},on:{"change":_vm.handleChange},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }